"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HydrogenToVenus = void 0;
const Tags_1 = require("../Tags");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class HydrogenToVenus extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.HYDROGEN_TO_VENUS,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.SPACE],
            cost: 11,
            tr: { venus: 1 },
            metadata: {
                cardNumber: '231',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.venus(1).br.br;
                    b.floaters(1).secondaryTag(Tags_1.Tags.VENUS).slash().jovian().played;
                }),
                description: 'Raise Venus 1 step. Add 1 Floater to A Venus CARD for each Jovian tag you have.',
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const jovianTags = player.getTagCount(Tags_1.Tags.JOVIAN);
        const floatersCards = player.getResourceCards(ResourceType_1.ResourceType.FLOATER).filter((card) => card.tags.includes(Tags_1.Tags.VENUS));
        if (jovianTags > 0) {
            if (floatersCards.length === 1) {
                player.addResourceTo(floatersCards[0], { qty: jovianTags, log: true });
            }
            if (floatersCards.length > 1) {
                return new SelectCard_1.SelectCard('Select card to add ' + jovianTags + ' floater(s)', 'Add floater(s)', floatersCards, (foundCards) => {
                    player.addResourceTo(foundCards[0], { qty: jovianTags, log: true });
                    player.game.increaseVenusScaleLevel(player, 1);
                    return undefined;
                });
            }
        }
        player.game.increaseVenusScaleLevel(player, 1);
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, venusIncrease: 1 });
    }
}
exports.HydrogenToVenus = HydrogenToVenus;
//# sourceMappingURL=HydrogenToVenus.js.map